"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconDownload } from '../../../Icon/components/icons/IconDownload.mjs';
import { IconExternalLink } from '../../../Icon/components/icons/IconExternalLink.mjs';
import locales from '../../../../../../_virtual/_.locale.json@d7a4ca29c343fa700bb5aa84d322958b.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const LinkIcon = (props) => {
  const { unstyled, target, download } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  if (unstyled) {
    return null;
  }
  if (download) {
    return /* @__PURE__ */ jsx(IconDownload, { "aria-label": stringFormatter.format("link.download") });
  }
  if (target === "_blank") {
    return /* @__PURE__ */ jsx(IconExternalLink, { "aria-label": stringFormatter.format("link.external") });
  }
  return null;
};

export { LinkIcon, LinkIcon as default };
//# sourceMappingURL=LinkIcon.mjs.map
